module.exports = __webpack_public_path__ + "img/shop.69150d7b.png";